import { Adapter, SendToOptions } from './adapter';

declare global {
  interface Window {
    $jk: any
    $micro: any;
  }
}

// TODO: test
export default class AdapterImpl implements Adapter {
  private $jk: any
  public async init(): Promise<void> {
    this.$jk = window.$jk || window.$micro;
    if (!this.$jk) {
      console.error('请将实例化后的开放平台 SdkJs 挂载到 window.$jk');
    }
  }
  public async sendTo(_config: any, { channelID, ...opts }: SendToOptions): Promise<void> {
    switch (channelID) {
      case 'wxt': {
        this.$jk.shareToWechat({
          scene: 1,
          ...opts,
        });
        break;
      }
      case 'wxf': {
        this.$jk.shareToWechat({
          scene: 2,
          ...opts,
        });
        break;
      }
      case 'qqf': {
        this.$jk.shareToQQ({
          scene: 2,
          ...opts,
        });
        break;
      }
      case 'qqz': {
        this.$jk.shareToQQ({
          scene: 1,
          ...opts,
        });
        break;
      }
    }
  }
};
